import { FetchApi } from '../lib/anuket-http';
import { configs } from '../configs';

import { getToken } from '../utils/isLoggedIn';

export async function createRace(raceData) {
  const token = await getToken();
  const url = configs.ATHLINKS_API_HOST + `/Events/Race/Api/Create`;

  return new Promise((resolve, reject) => {
    FetchApi.doFetch(
      url,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(raceData)
      }
    ).subscribe(
      (msg) => {
        if (msg.errorMessage) {
          const modelErrors = (msg.result || {}).modelErrors || [];
          reject(modelErrors.length > 0
            ? modelErrors.map((err) => err.error)
            : msg.errorMessage
          );
        } else {
          resolve(msg);
        }
      },
      (error) => {
        reject(error instanceof Error ? error.message : error);
      });
  });
}

export function fetchSimilarRaces(raceData) {

  const url = configs.ATHLINKS_API_HOST + `/Events/Race/Api/SearchSimilar`;

  const searchData = {
    city: raceData.city,
    term: raceData.name,
    startDate: raceData.startDateTime
  };

  return new Promise((resolve, reject) => {
    FetchApi.doFetch(
      url,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(searchData)
      }
    ).subscribe(
      (msg) => {
        if (msg.errorMessage) {
          reject(msg.errorMessage);
        } else {
          resolve(msg.result);
        }
      },
      (error) => {
        reject(error instanceof Error ? error.message : error);
      });
  });
}

export function fetchRacesTypeAhead(term) {
  const url = configs.ATHLINKS_API_HOST + `/Search/RaceTypeAhead?term=${term}`;

  return new Promise((resolve, reject) => {
    FetchApi.doFetch(
      url,
      {method: 'GET'}
    ).subscribe(
      (msg) => {
        resolve(msg.args.html.Races);
      },
      (error) => {
        reject(error instanceof Error ? error.message : error);
      });
  });
}



/** WEBPACK FOOTER **
 ** ./data/CreateRaceApi.js
 **/